'use client';

import React from 'react';
import MultiLevelMenu from './MultiLevelMenu';

const Menu = (props) => {
  const menuTree = props.menuTree || [];
  return (
    <div className="flex justify-between items-center w-full ">
      <div className="bg-[#DB3700] text-white w-full container">
        <MultiLevelMenu
          menuData={menuTree.filter((item) => !['hoi-dap', 'lien-he', 'so-do-cong'].includes(item?.slug))}
          websiteCode={props.websiteCode}
          locale={props.locale}
        />
      </div>
    </div>
  );
};

export default Menu;
